import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material";
import { MAT_DATE_FORMATS, DateAdapter } from "@angular/material";
import { AppService, APP_DATE_FORMATS, AppDateAdapter } from "../../services/app.service";
import { OrderEditFormComponent } from "../order/order-edit-form/order-edit-form.component";
import { DataTableComponent } from "../datatable/datatable.component";
import { MasterService } from "../../services/master.service";
import { FinanceService } from "../../services/finance.service";
import { OrderService } from "../../services/order.service";
import { ComponentService } from '../../services/component.service';
import { SharedService } from "../../services/shared";
import { Datatable } from "../../models/datatable.model";
import { AjaxService } from "../../../../core/services/ajax.service";
import { SearchCriteria } from '../../models/finance.model';


@Component({
    selector: 'app-finance',
    templateUrl: './finance.component.html',
    styleUrls: ['./finance.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS
        }
    ]
})

export class FinanceComponent implements OnInit {

editFormDialogRef: MatDialogRef<OrderEditFormComponent>;
public data = [];
order: any;

currentDate: any;
translations: any = [];
orderStatusList: any = [];

weekNumber: Number = 0;
year: Number = 0;
//orderStatusId: Number;
filterText: string = "";
length: Number = 0;

totalCOD: Number = 0;
totalTransInvAmt: Number = 0;
totalRevenue: Number = 0;

formGroup: FormGroup;
formGroupErrors: any;
countryList: any = [];
//countryId: Number;

gridMessage: string = '';

//fromReceiveDate: Date ;
//toReceiveDate: Date;
searchCriteria = new SearchCriteria();
constructor(
    private formBuilder: FormBuilder, 
    public dialog: MatDialog, 
    public orderService: OrderService, 
    public financeService: FinanceService, 
    public appService: AppService, 
    public masterService : MasterService, 
    private datatableComponent: DataTableComponent, 
    private datatableProp: Datatable, 
    private sharedService: SharedService,
    private comService: ComponentService,
    private _ajaxService: AjaxService) { 
    this.formGroupErrors = {
        Status: {}
    };
}

ngOnInit() {
    this.appService.showLoading();
    this.currentDate = new Date();
    this.bindOrderStatus();
}

getFinanceOrders(): void {
    this.appService.showLoading();
    // var fromNum = this.inpFromWeekNumber.nativeElement.value == '' ? '0' : this.inpFromWeekNumber.nativeElement.value;
    // var fromYr = this.inpFromYear.nativeElement.value == '' ? '0' : this.inpFromYear.nativeElement.value;
    // var toNum = this.inpToWeekNumber.nativeElement.value == '' ? '0' : this.inpToWeekNumber.nativeElement.value;
    // var toYr = this.inpToYear.nativeElement.value == '' ? '0' : this.inpToYear.nativeElement.value;
    this.searchCriteria.FromReceiveDate = this.appService.JSONDate(this.searchCriteria.FromReceiveDate);
    this.searchCriteria.ToReceiveDate = this.appService.JSONDate(this.searchCriteria.ToReceiveDate);
    this.financeService.allFinance(this.searchCriteria).subscribe(
    res => this.getFinanceOrdersSuccess(res),
    error => this.apiFaillure(error)
    );
}

getFinanceOrdersSuccess(res): void {
    this.data = [];
    this.sharedService.Data.next(this.data);
    if (res.Status == 1) {
        
        this.data = JSON.parse(res.Data).Table;
        if(this.data.length > 0){
            this.datatableProp = this.appService.mapDataTableProp(this.datatableProp, JSON.parse(res.Data).Table1[0]);
            this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
        }else
            this.data = JSON.parse(res.Data).Table;

        this.setGridMessage();	
        this.sharedService.Data.next(this.data);
        this.appService.hideLoading();
    } else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

exportToPdf(){
    this.appService.showLoading();
    // this.inpFromWeekNumber.nativeElement.value = "";
    // this.inpFromYear.nativeElement.value = "";
    this.searchCriteria.OrderStatus = 151;
    this.financeService.exportToPdf(-1, -1, -1, -1, this.searchCriteria.OrderStatus, 0, this.searchCriteria.CountryCode).subscribe(
        res => this.exportToPdfSuccess(res),
        error => this.apiFaillure(error)
    );
}

exportToPdfSuccess(res){
    this.appService.hideLoading();
    if(res.Data != null){
        window.open(res.Data, '_blank');
    }
}

setGridMessage(){
    if(this.data.length == 0){
        this.gridMessage = this.translations.msgNoDataAvailable;
    }else{
        this.gridMessage = '';
    }
}

setPageTranslations() {
    this.comService.get('finance').subscribe((res) => {
        this.translations = JSON.parse(res['Data']);
        this.appService.hideLoading();
    });
}

go(){
    this.getFinanceOrders();
}

bindOrderStatus(): void {
    this.masterService.selectSysData("OrderStatus","").subscribe(
    res => this.getOrderStatusSuccess(res),
    error => this.apiFaillure(error)
    );
}

getOrderStatusSuccess(res): void {
    if (res.Data != null) {
        this.setPageTranslations();	
        this.orderStatusList = JSON.parse(res.Data);
        // this.inpOrderStatus.value = this.inpOrderStatus.value == undefined ? 0 : this.inpOrderStatus.value;
        // this.searchCriteria.OrderStatus = this.searchCriteria.OrderStatus;        
        this.getCountries();
    } else {
    this.apiFaillure(res.Message);
}
}

apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

applyFilter(filterValue: any) {
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getFinanceOrders();
}

getDataArray(row, columns){
    var arr_data = [];
    for(var i = 0; i < columns.length; i++){
        var column_data = row[columns[i]] != undefined ? row[columns[i]] : '';
        arr_data.push(column_data);
    }
    return arr_data;
}

getTotal(header){
    var total = 0;
    if(this.data != undefined && this.data.length > 0){
        for(var i = 0; i < this.data.length; i++){
            total += Number(this.data[i][header]);
        }
    }
    return total;
}

editRecord(e): void {
    this.appService.showLoading();
    this.orderService.select(e.currentTarget.id).subscribe(
    res => this.selectSuccess(res),
    error => this.apiFaillure(error)
    );
}

selectSuccess(res): void {
    if (res.Status == 1) {
        this.order = JSON.parse(res.Data)[0];
        this.editFormDialogRef = this.dialog.open(OrderEditFormComponent, {
            disableClose: true,
            data: this.order,
            panelClass: "my-dialog"
        });
        this.editFormDialogRef.afterClosed().subscribe(response => {
            this.appService.showLoading();
            this.data = [];
            this.sharedService.Data.next(this.data);
            this.bindOrderStatus();
            this.getCountries();
        });
    } else if (res.Status == -1) {
    this.apiFaillure(res.Message);
}
}

getCountries(){
    this._ajaxService.GET("Master.svc/mastercountrycodelist").subscribe(response => {
        this.countryList = JSON.parse(response.Data);
        // this.inpCountryCode.value = this.inpCountryCode.value == undefined ? 0 : this.inpCountryCode.value;
        // this.searchCriteria.CountryCode = this.inpCountryCode.value;
        this.gridMessage = this.translations.msgNoDataAvailable;
    });
}

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/finance/finance.component.ts